import { FaFilter } from "react-icons/fa";
import Tooltip from "../ToolTip";

const FilterButton = ({ action, content }) => {
  return (
    <Tooltip content={content}>
      <button
        onClick={() => action ? action() : null}
        className="p-1.5 text-orange-600 hover:bg-orange-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-orange-700 bg-opacity-10 flex transition-all duration-100 items-center"
      >
        <FaFilter className="text-[10px]"/>
      </button>
    </Tooltip>
  )
}

export default FilterButton;
